// extracted by mini-css-extract-plugin
export var columnItem = "_dj-3";
export var columnItemDraggable = "_dj-4";
export var dragHandle = "_dj-0";
export var dragHandleHovered = "_dj-1";
export var dropdown = "_dj-5";
export var dropdownContent = "_dj-7";
export var dropdownInner = "_dj-6";
export var filterDropdownHeader = "_dj-8";
export var icon = "_dj-2";
export var sectionDivider = "_dj-9";